/** @format */

import Master from '../Layouts/Master';
import { success } from '../../Shared/Components/Toast';
import { useState } from 'react';
import useApi from '../../Shared/hooks/api/Index';

const UploadFile = () => {
	const [filePath, setFilePath] = useState(undefined);
	const [file, setFile] = useState(undefined);
	const [loading, setLoading] = useState(false);

	const uploadFile = async (e) => {
		e.preventDefault();
		setLoading(true);
		await useApi.post(
			'/upload',
			{ file: file },
			(res) => {
				setFilePath(res.data.data.url ?? res.data.data.path);
				setLoading(false);
			},
			(err) => {
				setLoading(false);
			},
			true,
		);
	};

	const copyToClipboard = () => {
		let filePath = document.getElementById('file-path');
		navigator.clipboard.writeText(filePath.textContent);
		success('آدرس فایل با موفقیت کپی شد');
	};

	return (
		<Master>
			<form onSubmit={(e) => uploadFile(e)}>
				<div className='row rounded p-2 mt-3'>
					<div className='col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10'>
						<div className='form-group'>
							<label>فایل</label>
							<input
								type='file'
								className='form-control'
								onChange={(e) => setFile(e.target.files[0])}
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
						<div className='form-group'>
							{loading ? (
								<div
									className='spinner-border spinner-border-sm text-white mb-1'
									role='status'></div>
							) : (
								<button type='submit' className='bg-purple btn text-white mt-4'>
									آپلود فایل
								</button>
							)}
						</div>
					</div>
					{filePath !== undefined && (
						<div className='col-12'>
							<div className='alert alert-success'>
								<i
									className='fad fa-copy f-20 c-pointer'
									onClick={copyToClipboard}></i>
								<span className='mx-2 p-0' id='file-path'>
									{filePath}
								</span>
							</div>
						</div>
					)}
				</div>
			</form>
		</Master>
	);
};

export default UploadFile;
